export default __webpack_public_path__ + "static/media/reja-logo.fe147f00.jpg";